export default function IconPlay({ className }: { className?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            className={className}
        >
            <g clipPath="url(#clip0_3226_13936)">
                <path
                    d="M0 12C0 5.373 5.373 0 12 0C18.627 0 24 5.373 24 12C24 18.627 18.627 24 12 24C5.373 24 0 18.627 0 12Z"
                    fill="white"
                    fillOpacity="0.2"
                />
                <path
                    d="M0.375 12C0.375 5.58 5.58 0.375 12 0.375C18.42 0.375 23.625 5.58 23.625 12C23.625 18.42 18.42 23.625 12 23.625C5.58 23.625 0.375 18.42 0.375 12Z"
                    stroke="white"
                    strokeMiterlimit="10"
                />
                <path
                    d="M16.332 11.7469L9.697 7.57188C9.406 7.39088 9 7.57188 9 7.87788V16.1219C9 16.4279 9.401 16.6099 9.697 16.4279L16.332 12.3589C16.575 12.2099 16.575 11.8949 16.332 11.7379V11.7469Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_3226_13936">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
